import { apiRequest } from "../http";

// 获取公共资源地址集
export const getPublicUrl = () => apiRequest.get("/public-url");
